import { useTranslate } from '@refinedev/core';
import { Form, Slider } from 'antd';

/**
 * `search_popularity` slider — the whole content of the "search" section in
 * every `user_catalog` form. The 0-10 scale mirrors the API's range.
 */
export const SearchPopularityField = () => {
  const t = useTranslate();

  return (
    <Form.Item
      name="search_popularity"
      label={t('user_catalog.common.fields.search_popularity')}
    >
      <Slider min={0} max={10} step={1} marks={{ 0: '0', 5: '5', 10: '10' }} />
    </Form.Item>
  );
};
